import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './Login.css'

function Login() {
  const [botId, setBotId] = useState('')
  const navigate = useNavigate()

  const handleLogin = () => {
    if (botId.trim()) {
      navigate(`/${botId}`)
    } else {
      alert('Please enter a valid ID')
    }
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1>Welcome to Ultimo Bots</h1>
        <p>Login with your <strong>bot_id</strong> or create your AI agent in just 2 minutes.</p>
        <input
          type="text"
          value={botId}
          onChange={(e) => setBotId(e.target.value)}
          placeholder="Enter your Bot ID"
          className="login-input"
        />
        <button onClick={handleLogin} className="login-button">
          Start Chat
        </button>
        <div className="divider">or</div>
        <a
          href="https://portal.ultimo-bots.com/create-chatbot"
          className="create-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Create a Smart AI Agent
        </a>
      </div>
    </div>
  )
}

export default Login
